import { useTranslation } from "react-i18next";

/**
 * Official "Barra de Assinaturas" for NUT II Algarve projects (with IEFP).
 *
 * Layout: IEFP · ALGARVE 2030 · PORTUGAL 2030 · Cofinanciado pela União Europeia.
 * Both assets are official, unaltered (per EU & Portugal 2030 graphic norms).
 *
 * - Rendered on a white background panel because the IEFP logo and the
 *   "Cores" variant of the Algarve bar are designed for light backgrounds.
 * - Compact size (max-width capped), centered, sits at the very bottom of the footer.
 */
export default function CoFinanciamentoBar() {
  const { t } = useTranslation();
  const label = t("cofin.label");

  return (
    <div
      className="pt-6 pb-1 flex justify-center"
      data-testid="cofinanciamento-bar"
      role="contentinfo"
      aria-label={label}
    >
      <div className="bg-white rounded-md px-4 py-2.5 inline-flex items-center gap-4 shadow-sm">
        <img
          src="/cofinanciamento/iefp.webp"
          alt="IEFP"
          loading="lazy"
          decoding="async"
          className="h-10 w-auto"
        />
        <span aria-hidden="true" className="h-9 w-px bg-slate-200" />
        <img
          src="/cofinanciamento/algarve2030-cores.svg"
          alt={label}
          loading="lazy"
          decoding="async"
          className="h-7 w-auto"
        />
      </div>
    </div>
  );
}
